module.exports = __webpack_public_path__ + "img/48.6e5fab03.jpg";